import {
  FETCH_MAIN_RINGS,
  FETCH_HOLDER_RINGS,
  SELECT_ACTIVE_MAIN_RING,
  SELECT_ACTIVE_HOLDER_RINGS,
  CLOSE_MODALS,
} from "./types";

import ContentfulApi from "../../lib/ContentfulApi";

export const initRings = (query) => {
  return (dispatch) => {
    console.log("initializing rings...");
    // Fetch Main Rings:
    dispatch(fetchMainRings(query));

    // Fetch holder rings:
    dispatch(fetchHolderRings(query));
  };
};

export const fetchMainRings = (query) => {
  return (dispatch) => {
    const api = new ContentfulApi();
    api
      .getMainRings()
      .then((response) => {
        if (response.items && response.includes) {
          const formattedResponse = formatResponse(response);
          dispatch({
            type: FETCH_MAIN_RINGS,
            payload: formattedResponse,
          });
          // Select active main ring:
          dispatch(selectActiveMainRing(query));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const fetchHolderRings = (query) => {
  return (dispatch) => {
    const api = new ContentfulApi();

    api
      .getHolderRings()
      .then((response) => {
        if (response.items && response.includes) {
          const formattedResponse = formatResponse(response, false);
          dispatch({
            type: FETCH_HOLDER_RINGS,
            payload: formattedResponse,
          });
          // Select active holder ring:
          dispatch(selectActiveHolderRings(query));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const selectActiveMainRing = (queryParams) => {
  return (dispatch, getState) => {
    if (!getState().ring.mainRings) {
      console.log("Could not find main rings.");
      return;
    }
    const mainRings = getState().ring.mainRings.items;
    let activeRing = null;
    const defaultRingDiamondSize = getState().configuratorPage
      .defaultRingDiamondSize
      ? getState().configuratorPage.defaultRingDiamondSize
      : 0.5;
    // IF query vars are not available:
    if (!queryParams || Object.keys(queryParams).length === 0) {
      for (let i = 0; i < mainRings.length; i++) {
        if (mainRings[i].fields.diamondSize === defaultRingDiamondSize) {
          activeRing = mainRings[i];
        }
      }
    } else {
      // If query vars are available:
      activeRing = findCorrespondingMainRing(
        mainRings,
        queryParams,
        defaultRingDiamondSize
      );
    }
    if (activeRing) {
      dispatch({
        type: SELECT_ACTIVE_MAIN_RING,
        payload: activeRing,
      });
    }
  };
};

export const selectActiveRingByID = (id, mainRing = true) => {
  return (dispatch, getState) => {
    if (getState().ring.mainRings && mainRing && id) {
      const newRing = getState().ring.mainRings.items.filter(
        (item) => item.sys.id === id
      );
      if (newRing) {
        dispatch({
          type: SELECT_ACTIVE_MAIN_RING,
          payload: newRing[0],
        });
      }
    }
  };
};

export const selectActiveRingFromModal = (ring, mainRing = true) => {
  return (dispatch) => {
    const type = mainRing
      ? SELECT_ACTIVE_MAIN_RING
      : SELECT_ACTIVE_HOLDER_RINGS;
    if (ring) {
      dispatch({
        type: type,
        payload: ring,
      });
      dispatch({
        type: CLOSE_MODALS,
      });
    }
  };
};

const findCorrespondingMainRing = (
  mainRings,
  queryParams,
  defaultRingDiamondSize
) => {
  if (mainRings && mainRings.length && queryParams && defaultRingDiamondSize) {
    let activeRing = null;
    // Case Default ring:
    if (queryParams.ring === "default") {
      // Create array of all the rings of that collection for fall back if default ring size is not found.
      const collectionRings = [];
      for (let i = 0; i < mainRings.length; i++) {
        if (
          queryParams.collection.toLowerCase() ===
          mainRings[i].fields.collectionTitle.split(" ").join("-").toLowerCase()
        ) {
          collectionRings.push(mainRings[i]);
          // Default diamond size is set in Contentful, use that ring if possible as default.
          if (defaultRingDiamondSize === mainRings[i].fields.diamondSize) {
            activeRing = mainRings[i];
          }
        }
      }
      if (!activeRing) {
        if (collectionRings && collectionRings.length) {
          // Fallback to first ring of the collection:
          activeRing = collectionRings[0];
        }
        // If there wasn't a ring with
      }
    } else {
      // Get ID from query var ring:
      for (let i = 0; i < mainRings.length; i++) {
        if (
          mainRings[i] &&
          mainRings[i].sys.id &&
          mainRings[i].sys.id === queryParams.ring
        ) {
          activeRing = mainRings[i];
        }
      }
    }
    return activeRing;
  }
  return null;
};

export const selectActiveHolderRings = (queryParams) => {
  return (dispatch, getState) => {
    if (!getState().ring.holderRings) {
      console.log("Could not find holder rings.");
      return;
    }
    const holderRings = getState().ring.holderRings.items;
    let activeHolderRings = null;
    if (queryParams && holderRings) {
      // If query vars are available:
      activeHolderRings = findCollectionHolderRing(queryParams, holderRings);
    }
    if (activeHolderRings) {
      dispatch({
        type: SELECT_ACTIVE_HOLDER_RINGS,
        payload: activeHolderRings,
      });
    }
  };
};

const findCollectionHolderRing = (queryParams, holderRings) => {
  if (queryParams && holderRings) {
    let activeHolderRing = null;
    // Default holder ring:
    if (
      queryParams.holder === "default" ||
      Object.keys(queryParams).length === 0
    ) {
      const collection = queryParams.collection
        ? queryParams.collection.toLowerCase()
        : "Lumi";
      for (let i = 0; i < holderRings.length; i++) {
        if (
          holderRings[i].fields.collectionTitle
            .split(" ")
            .join("-")
            .toLowerCase() === collection
        ) {
          activeHolderRing = holderRings[i];
          break;
        }
      }
      // IF THERE WAS NO HOLDER RING WITH CURRENT COLLECTION, DEFAULT TO LUMI:
      if (activeHolderRing === null) {
        for (let i = 0; i < holderRings.length; i++) {
          if (holderRings[i].fields.collectionTitle === "Lumi") {
            activeHolderRing = holderRings[i];
            break;
          }
        }
      }
    }
    // Holder is selected, use ID:
    else {
      for (let i = 0; i < holderRings.length; i++) {
        if (holderRings[i].sys.id === queryParams.holder) {
          activeHolderRing = holderRings[i];
        }
      }
    }
    return activeHolderRing;
  }
  return null;
};

const mapImagesURLs = (response, mainRing = true) => {
  if (response.items && response.includes && response.includes.Asset) {
    const imageKeys = mainRing
      ? [
          "imagePlatinum",
          "imagePlatinumDiamond",
          "imagePlatinumShadow",
          "imageRoseGold",
          "imageRoseGoldDiamond",
          "imageRoseGoldShadow",
          "imageWhiteGold",
          "imageWhiteGoldDiamond",
          "imageWhiteGoldShadow",
          "imageYellowGold",
          "imageYellowGoldDiamond",
          "imageYellowGoldShadow",
        ]
      : [
          "imagePlatinumLower",
          "imagePlatinumUpper",
          "imagePlatinumShadow",
          "imageWhiteGoldUpper",
          "imageWhiteGoldLower",
          "imageWhiteGoldShadow",
          "imageRoseGoldUpper",
          "imageRoseGoldLower",
          "imageRoseGoldShadow",
          "imageYellowGoldUpper",
          "imageYellowGoldLower",
          "imageYellowGoldShadow",
        ];
    for (let i = 0; i < response.includes.Asset.length; i++) {
      for (let y = 0; y < response.items.length; y++) {
        for (let x = 0; x < imageKeys.length; x++) {
          response.items[y] = findImageAsset(
            response.items[y],
            response.includes.Asset[i],
            imageKeys[x]
          );
        }
      }
    }
  }
  // fallback to returning the response
  return response;
};

const mapCollectionToRings = (data) => {
  if (
    data.items &&
    data.items.length &&
    data.includes &&
    data.includes.Entry &&
    data.includes.Entry.length
  ) {
    for (let i = 0; i < data.items.length; i++) {
      for (let y = 0; y < data.includes.Entry.length; y++) {
        if (
          data.items[i].fields &&
          data.items[i].fields.collection &&
          data.items[i].fields.collection.sys.id ===
            data.includes.Entry[y].sys.id
        ) {
          data.items[i].fields.collectionTitle =
            data.includes.Entry[y].fields.title;
        }
      }
    }
    return data;
  }

  return data;
};

const formatResponse = (response, mainRing = true) => {
  if (response) {
    // Map collections to response:
    let formattedResponse = mapCollectionToRings(response);
    formattedResponse = formatStoreFrontIds(formattedResponse);
    formattedResponse = mapImagesURLs(formattedResponse, mainRing);

    return formattedResponse;
  }

  return response;
};

const formatStoreFrontIds = (response) => {
  if (response && response.items && response.items.length) {
    for (let i = 0; i < response.items.length; i++) {
      if (response.items[i].fields) {
        if (response.items[i].fields.shopifyProductPlatinum) {
          response.items[i].fields.shopifyProductPlatinum = atob(
            response.items[i].fields.shopifyProductPlatinum
          ).split("/")[4];
        }
        if (response.items[i].fields.shopifyProductYellowGold) {
          response.items[i].fields.shopifyProductYellowGold = atob(
            response.items[i].fields.shopifyProductYellowGold
          ).split("/")[4];
        }
        if (response.items[i].fields.shopifyProductWhiteGold) {
          response.items[i].fields.shopifyProductWhiteGold = atob(
            response.items[i].fields.shopifyProductWhiteGold
          ).split("/")[4];
        }
        if (response.items[i].fields.shopifyProductRoseGold) {
          response.items[i].fields.shopifyProductRoseGold = atob(
            response.items[i].fields.shopifyProductRoseGold
          ).split("/")[4];
        }
      }
    }
  }

  return response;
};

const findImageAsset = (fieldsItem, assetsItem, key) => {
  if (
    fieldsItem &&
    fieldsItem.fields &&
    fieldsItem.fields[key] &&
    assetsItem &&
    key
  ) {
    if (fieldsItem.fields[key].sys.id === assetsItem.sys.id) {
      fieldsItem.fields[`${key}URL`] =
        "https://" + assetsItem.fields.file.url.substring(2);
      return fieldsItem;
    }
  }
  return fieldsItem;
};
